var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66406 5.83398L8.46816 10.5969C9.01914 10.9825 9.29463 11.1754 9.59428 11.2501C9.85898 11.3161 10.1358 11.3161 10.4005 11.2501C10.7002 11.1754 10.9757 10.9825 11.5266 10.5969L18.3307 5.83398M5.66406 16.6673H14.3307C15.7309 16.6673 16.4309 16.6673 16.9657 16.3948C17.4361 16.1552 17.8186 15.7727 18.0582 15.3023C18.3307 14.7675 18.3307 14.0674 18.3307 12.6673V7.33398C18.3307 5.93385 18.3307 5.23379 18.0582 4.69901C17.8186 4.2286 17.4361 3.84615 16.9657 3.60647C16.4309 3.33398 15.7309 3.33398 14.3307 3.33398H5.66406C4.26393 3.33398 3.56387 3.33398 3.02909 3.60647C2.55868 3.84615 2.17623 4.2286 1.93655 4.69901C1.66406 5.23379 1.66406 5.93385 1.66406 7.33398V12.6673C1.66406 14.0674 1.66406 14.7675 1.93655 15.3023C2.17623 15.7727 2.55868 16.1552 3.02909 16.3948C3.56387 16.6673 4.26393 16.6673 5.66406 16.6673Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.a58d0cc088580b731edb1a17639e3c17.svg";
export { ForwardRef as ReactComponent };